<template>
  <div class="content">

    <div class="d-block-create-msg">
      <div class="container-fluid" :class="{'is-template': isTemplate}">
        <div class="row">
          <div class="col-md-6 col-sm-12 left-column">
            <div v-if="message">
              <h1 class="page-title">
<!--                <span>Create Auto Message</span>-->
                <span>{{message.title}}</span>
                <span class="del-text">Edit your text message response</span>
              </h1>

              <h3>Timing</h3>

              <div class="auto-msg-timing">
                <span class="icon"><font-awesome-icon :icon="['far', 'clock']"/></span>
                {{message.time}}
              </div>

              <div class="clearfix choose-text-message">
                <a href="#"
                   class="link-to-create-list"
                   v-on:click.prevent="isSelectTemplateModal = true"
                >Need Inspiration? Start with a Template</a>
                <h3>Text Message</h3>
                <select-tags ref="selectTag"
                             v-on:txt-change="onTxtChange"
                             :block-id="'new-msg'"
                ></select-tags>

                <div class="upload-textarea-wrap upload-textarea-wrap-new-smg">

                  <div class="dropdown-attach-to-msg dropdown-attach-to-msg-down">

                    <a class="btn btn-sm btn-sm-bold btn-attach dropbtn" data-dropdown=".select-actions" href="#"></a>

                    <add-attachment
                        :charity-info="activeCharityInfo"
                        v-on:select-attachment="selectAttachment"
                        v-bind:imageError.sync="imageError"
                        v-bind:imageIsLoading.sync="imageIsLoading"
                        v-bind:imageLoadingPercent.sync="imageLoadingPercent"
                    ></add-attachment>

                  </div>
                  <textarea name="new-msg" id="new-msg" class="new-msg" placeholder="Type a message..."></textarea>
                  <button class="btn-icons btn-merge-tags"
                          v-on:mousedown.prevent="$refs.selectTag.toggle()"
                  ></button>
                </div>
              </div>

              <input type="hidden" class="attach-link">
              <div class="row">
                <div class="col-xs-6">
                  <div class="">
                    <h3 class="attachment-title">Attachment</h3>

                    <attachment-edit v-if="attachmentInfo && attachmentInfo.type!='none'"
                                     :attachment-info="attachmentInfo"
                                     :charity-info="activeCharityInfo"
                                     v-on:remove-attachment="attachmentInfo = null"
                    ></attachment-edit>

                    <div v-else class="none-attachment">
                      <a class="dropbtn" data-dropdown=".select-actions" href="#">+ Add an Attachment</a>
                    </div>

                  </div>

                  <div v-if="imageError" class="image-upload-error error-msg ">{{imageError}}</div>
                  <div v-if="imageIsLoading" class="progress-big">
                    <div class="progress">
                      <div class="progress-val" :style="{'width': imageLoadingPercent + '%'}"></div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="text-right btn-wrap auto-msg-status">
                    <!--<a href="#" class="btn btn-sm btn-cancel" v-on:click.prevent="$router.go(-1)">Cancel</a>-->

                    <div class="inner">
                      <p>Message Status</p>
                      <div style="width: 125px">
                        <el-switch v-model="enabled"
                                   :active-text="`Turned ${(enabled ? 'ON' : 'OFF')}`"
                        ></el-switch>
                      </div>
                    </div>

                    <a href="#" v-on:click.prevent="saveAutoMessage" class="btn btn-sm">Save</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-6 col-sm-12 right-column">
            <div class="preview-msg clearfix">
              <div class="inner">
                <div class="wrap" v-if="activeCharityInfo">
                  <div class="ch-logo">
                    <img v-if="activeCharityInfo.logo_transparent"
                         :src="activeCharityInfo.logo_transparent"
                         :alt="activeCharityInfo.charity_name">
                  </div>
                  <div class="ch-name">{{activeCharityInfo.charity_name}}</div>
                </div>
                <div class="msg-text">{{previewText}}<span v-if="!previewText" class="placeholder">Preview of your message...</span>
                </div>

                <attachment v-if="attachmentInfo && attachmentInfo.type!='none'"
                            :attachment-info="attachmentInfo"
                            :charity-info="activeCharityInfo"
                            :is-loaded-media-wrap="false"
                ></attachment>
                <!--<div class="preview-img"></div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="isSelectTemplateModal"
           v-on:close-modal="isSelectTemplateModal = false"
           v-on:use-template="useTemplate"
           :charity-info="activeCharityInfo"
           :folders="[...folders]"
           :modal-name="'select-template'"></modal>

  </div>
</template>

<script>
  /*eslint-env jquery*/
  import {getAllAutoMessages, updateMessage, getFolders} from '@/utils/api';

  import MsgMenu from './menu.vue';
  import AttachmentEdit from './attachment-edit.vue';
  import Attachment from './attachment.vue';
  import AddAttachment from './add-attachment.vue';
  import SelectTags from './select-tags.vue';
  import {getAttachmentBlock} from '@/utils/attachments';
  import Switches from 'vue-switches';
  import Modal from '../Modal/index.vue';
  import {defParams} from '@/utils/messages';
  import merge from 'deepmerge';
  import previewMixin from './preview-mixin';
  import useTemplatesMixin from './use-templates-mixin';
  import {mapState} from "vuex";

  export default {
    name: 'AutoMessages',
    components: {
      MsgMenu,
      AttachmentEdit,
      Attachment,
      AddAttachment,
      Switches,
      SelectTags,
      Modal
    },
    props: [
      'isTemplate',
      'isNew',
    ],
    metaInfo: {
      title: 'Auto Messages - Edit',
    },
    mixins: [previewMixin, useTemplatesMixin],
    mounted() {
      getFolders().then(folders => this.folders = folders);

      const self = this;
      getAllAutoMessages().then((messages) => {

        const msgId = parseInt(this.$route.params.msgId);
        messages = messages.filter(msg => parseInt(msg.id) === msgId);

        if (messages.length && msgId in defParams) {
          let message = merge(messages.shift(), defParams[msgId]);

          this.enabled = !!parseInt(message.enabled);

          let attachmentInfo = null;

          if (message.attachment) {
            attachmentInfo = {
              type: 'add-photo',
              link: message.attachment,
            };
          }
          else {
            let msgText = message.body;
            let firstLine = msgText.split(/\r\n|\r|\n/)[0].trim();
            attachmentInfo = getAttachmentBlock(firstLine, true);

            if ('type' in attachmentInfo && attachmentInfo.type !== 'none') {
              msgText = msgText.replace(firstLine, '').trim();
            }
            message.body = msgText;
          }
          this.attachmentInfo = attachmentInfo;

          this.message = message;
        }
        else {
          this.$router.push({name: 'AutoMessages'});
        }

        self.$nextTick(() => {
          $('#new-msg').emojioneArea({
            pickerPosition: 'right',
            filters: {
              symbols: {icon: 'heart'},
              flags: {icon: 'checkered_flag'},
            },
            events: {
              emojibtn_click: () => {
                $('.emojionearea').find('.emojionearea-button-close').click();
                self.onTxtChange();
              },
              keyup: () => self.onTxtChange(),
              change: () => self.onTxtChange(),
              paste: () => self.onTxtChange(),
              mouseup: () => self.onTxtChange(),
              click: () => self.onTxtChange(),
              'focus': () => self.onTxtChange(),
            },
          });
          if (self.message) {
            const tmp = self.message.body.replaceAll('[', '<span class="merge-tag-edit">[').
              replaceAll(']', ']</span>').
              replaceAll('\n', '<br>')
            ;

            $('#new-msg').data('emojioneArea').editor.html(tmp);
            self.onTxtChange();
          }
        });
      });
    },
    methods: {
      selectAttachment: function(attachment) {
        this.imageError = '';
        this.attachmentInfo = attachment;
      },
      saveAutoMessage: function() {

        let text = $('#new-msg').data('emojioneArea').getText().trim();
        let attachment = false;
        if (text === '') {
          return false;
        }
        if (this.attachmentInfo && this.attachmentInfo.type !== 'none') {
          // If the link is an image, send it as an attachment
          if (this.attachmentInfo.type === 'add-photo') {
            attachment = this.attachmentInfo.link;
          }
          else {
            // Otherwise, prepend it to the message body.
            text = `${this.attachmentInfo.link}\n${text}`;
          }
        }

        updateMessage(this.$route.params.msgId, text, +this.enabled, attachment).then(() => {
          this.$router.push({name: 'AutoMessages'});
        }).catch((err) => {
          alert(err.error || 'An error has occurred, please try again.');
        });
      },
      onTxtChange: function() {
        this.text = $('#new-msg').data('emojioneArea').getText();
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
    },
    data() {
      return {
        folders: [],
        isSelectTemplateModal: false,
        text: '',
        enabled: false,
        message: null,
        attachmentInfo: null,
        imageIsLoading: false,
        imageLoadingPercent: 0,
        imageError: '',
        value: '',
      };
    },
  };
</script>

<style lang="sass" scoped>
  .d-block-create-msg
    .link-to-create-list
      margin: 15px 0 7px
    .none-attachment
      color: rgba(53, 64, 82, 0.5)
    .auto-msg-timing
      height: 34px
      border-radius: 4px
      border: 1px solid #b4bfd4
      background-color: rgba(222, 229, 237, 0.5)
      font-size: 14px
      line-height: 1.29
      position: relative
      padding: 8px 10px 8px 44px
      font-weight: 700
      color: #677788
      .icon
        display: inline-block
        width: 34px
        position: absolute
        left: -1px
        top: -1px
        bottom: -1px
        background-color: #0d70e3
        color: #ffffff
        line-height: 34px
        text-align: center
        font-size: 14px
        border-top-left-radius: 4px
        border-bottom-left-radius: 4px
    .auto-msg-status
      font-size: 14px
      .btn
        vertical-align: middle
        margin-left: 25px
      .inner
        text-align: left
        display: inline-block
        vertical-align: middle
      p
        color: #677788
        font-style: normal
        font-weight: 600
        padding-bottom: 3px
        margin-bottom: 0
      label
        span
          color: #050926
          opacity: 0.5
          padding-left: 5px
          position: relative
          top: -1px
</style>
<style lang="sass">
  .auto-msg-status
    .vue-switcher-theme--dashboard
      input
        display: none
      & > div
        width: 21px
        height: 14px
        top: 0
        background-color: #0d70e3
        &:after
          // for the circle on the switch
          background-color: #f3f6f7
          margin-left: -12px
          top: 2px
          width: 10px
          height: 10px
      &.vue-switcher--unchecked
        div
          background-color: #e0e6ed
          &:after
            left: 14px
</style>
